var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gl-flex gl-flex-wrap gl-gap-2"},[_c('span',{staticClass:"gl-capitalize",attrs:{"data-testid":"state-text"}},[_vm._v(_vm._s(_vm.stateText))]),_vm._v(" "),(_vm.showDismissalReason)?_c('gl-badge',{attrs:{"variant":"neutral"}},[_vm._v(_vm._s(_vm.dismissalReasonText))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }